import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { IOffersForSpecificNewbuildingSearchSliderUnderground } from 'shared/types/newbuildingOffersCarousel';

import { FromUndergroundTime } from './parts/FromUndergroundTime';
import { UndergroundIcon } from './parts/UndergroundIcon';
import * as styles from './styles.css';

type IUndergroundProps = IOffersForSpecificNewbuildingSearchSliderUnderground;

export function Underground({ lineColor, name, transportType, cityType, timeDisplay }: IUndergroundProps) {
  return (
    <div className={styles['underground']} data-testid="underground">
      <div className={styles['underground-station']}>
        {lineColor && cityType && <UndergroundIcon lineColor={lineColor} undergroundType={cityType} />}
        <UIText2>{name}</UIText2>
      </div>
      {transportType && (
        <div className={styles['from-underground-time']}>
          <FromUndergroundTime transportType={transportType} timeTo={timeDisplay} />
        </div>
      )}
    </div>
  );
}
